<template>
  <div class="homepage-view">
    <section class="section">
      <div class="dc-login">
        <b-container>
          <b-row>
            <b-col sm="12" md="6" lg="4" offset-lg="1">
              <h5 class="mb-4">Benvenuto! Grazie a Corporate Benefit hai diritto a viaggiare a condizioni agevolate!</h5>
              <p>Benefit Travel è un servizio esclusivo che ti offre hotel con sconti fino al 50% e molte altre opportunità dedicate al turismo, che includono trasporti, esperienze e viaggi multitappa.</p>
              <p>Il tuo codice di autenticazione è già inserito: ti basta aggiungere alcuni dati, che utilizzeremo per confermare eventuali prenotazioni e fornire servizi di viaggio.</p>
              <p>Con Benefit Travel puoi costruire il tuo viaggio in qualunque parte del mondo e hai a disposizione un servizio clienti dedicato, attivo sette giorni su sette, che verifica ogni singola prenotazione alberghiera.</p>
            </b-col>
            <discount-code
              :discount_code_url="discount_code_url"
              :email_url="email_url"
            />
          </b-row>
        </b-container>
      </div>
    </section>

    <!--value props list-->
    <section class="section">
      <b-container>
        <point-list-01
            :pl="[
            {
              pl_icon: 'shield',
              pl_title: 'Tutti i servizi per i tuoi viaggi',
              pl_text: 'Un’offerta completa per organizzare ogni parte del tuo viaggio: dall’hotel ai trasporti, fino a esperienze, biglietti e tour.',
            },
            {
              pl_icon: 'happy_pin',
              pl_title: 'Per un cliente speciale',
              pl_text: 'Un servizio pensato per chi ha diritto a condizioni agevolate, con accesso dedicato e vantaggi esclusivi',
            },
            {
              pl_icon: 'hands',
              pl_title: 'La nostra assistenza',
              pl_text: 'Un team di assistenza italiano esperto e dedicato, al servizio di clienti speciali come te, per supportarti e verificare ogni prenotazione.',
            },
          ]"/>
      </b-container>
    </section>
  </div>
</template>

<script>
import Vue from 'vue' // per VueRecaptcha
import { VueReCaptcha } from 'vue-recaptcha-v3'
import PointList01 from '@library/blocks/point-list-01.vue'
import DiscountCode from '@travelc/components/blocks/discount_code'

export default {
  name: 'homepage-view',

  components: {
    'point-list-01': PointList01,
    'discount-code': DiscountCode,
  },

  props: {
    discount_code_url: {
      type: String,
      default: '',
    },
    name_url: {
      type: String,
      default: '',
    },
    surname_url: {
      type: String,
      default: '',
    },
    email_url: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {

    // inject logo pellegrini in header component
    const logo = document.querySelector('.site-header__logo .logo')
    if (logo) logo.innerHTML = '<img src="https://assets.salabam.com/customDesigns/logos/logo_corporate_benefit.png" alt="Corporate Benefit" />'

    if (this.get_config('recaptcha.enabled')) {
      Vue.use(VueReCaptcha, {
        siteKey: this.get_config('recaptcha.siteKey'),
      })
    }
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  ::v-deep {

    .btn-primary {
      display: none;
    }
  }

</style>